module.exports = "@media (min-width: 993px) {\n  .subscription-bar-visible {\n    margin-top: 30px !important;\n  }\n  .subscription-bar-visible #m_aside_left {\n    margin-top: 15px !important;\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.less
// module id = ./src/app/app.component.less
// module chunks = main